<div class="row">
  <inspectionSection-edit
    [processing]="processing"
    [inspectionSection]="section"
    (toggleSaveInspectionSection)="saveInspectionSection($event)"
    (toggleCancel)="cancel()"
  ></inspectionSection-edit>
</div>
